__turbopack_context__.v({
  "actionsRow": "ScrollTest-module__3U-kvG__actionsRow",
  "body": "ScrollTest-module__3U-kvG__body",
  "feedback": "ScrollTest-module__3U-kvG__feedback",
  "hintIcon": "ScrollTest-module__3U-kvG__hintIcon",
  "hoverOverlay": "ScrollTest-module__3U-kvG__hoverOverlay",
  "info": "ScrollTest-module__3U-kvG__info",
  "isActive": "ScrollTest-module__3U-kvG__isActive",
  "isSuccess": "ScrollTest-module__3U-kvG__isSuccess",
  "progressBar": "ScrollTest-module__3U-kvG__progressBar",
  "progressFill": "ScrollTest-module__3U-kvG__progressFill",
  "relative": "ScrollTest-module__3U-kvG__relative",
  "result-failed": "ScrollTest-module__3U-kvG__result-failed",
  "result-success": "ScrollTest-module__3U-kvG__result-success",
  "runner": "ScrollTest-module__3U-kvG__runner",
  "runnerDanger": "ScrollTest-module__3U-kvG__runnerDanger",
  "runnerSuccess": "ScrollTest-module__3U-kvG__runnerSuccess",
  "shell": "ScrollTest-module__3U-kvG__shell",
  "status-failed": "ScrollTest-module__3U-kvG__status-failed",
  "status-initial": "ScrollTest-module__3U-kvG__status-initial",
  "status-success": "ScrollTest-module__3U-kvG__status-success",
  "statusPill": "ScrollTest-module__3U-kvG__statusPill",
  "trackMarks": "ScrollTest-module__3U-kvG__trackMarks",
  "wrapper": "ScrollTest-module__3U-kvG__wrapper",
});
